import * as axios from 'axios';
import {getToken} from 'Global/AppService';
export const AxiosService = {
    async postData (url, payload, callback, inputHeader) {
        let httpHeaders = {
            headers:{
                'Authorization': "Bearer "+await getToken(),
                ...inputHeader
            }
        }
        axios.post(url, payload, httpHeaders)
        .then((response) => callback(response.data))
        .catch((error) => callback("", error.response));
    },
    async getData(url, inputHeader) {
      const config = {
        headers: {
          Authorization: "Bearer " + (await getToken()),
          ...inputHeader,
        },
      };
   
      return axios
        .get(url, config)
        .then((response) => response.data)
        .catch((error) => error.response);
    }   
}